import * as rechartComponents from 'recharts';

// rechartComponents.Line.defaultProps={
//     ...rechartComponents.Line.defaultProps,
//     stroke:"var(--primary)",

// }

// rechartComponents.CartesianGrid.defaultProps={
//     ...rechartComponents.CartesianGrid.defaultProps,
//     vertical:false,
//     stroke:"#f5f5f5",
// }

// rechartComponents.XAxis.defaultProps={
//     ...rechartComponents.XAxis.defaultProps,
//     tickCount: 2,
//     interval: 1,

// }


export default rechartComponents;